module.exports = __webpack_public_path__ + "img/yishi7.92f6ed35.jpg";